export enum QrCodeStatus {
    Free = 'Free',
    Used = 'Used',
    Cancelled = 'Cancelled'
}
